import React, {useRef} from 'react';
import {useDrag, useDrop, DropTargetMonitor} from 'react-dnd';
import {XYCoord} from 'dnd-core';
import {Gallery} from "@models/gallery";

// Every box of image
interface PreviewItemProps {
    item: Gallery;
    id: number;
    index: number
    moveCard: (dragIndex: number, hoverIndex: number) => void

}

interface DragItem {
    index: number
    id: string
    type: string
}

const style = {
    width: '150px',
    padding: '2px',
    cursor: 'move',
    display: 'inline-block',
    margin: "0 5px 0 10px"
}
const GalleryItemPreview: React.FC<PreviewItemProps> = ({id, item, index, moveCard, children}) => {
    const ref = useRef<HTMLDivElement>(null)
    const [, drop] = useDrop({
        accept: 'card',
        hover(dragItem: DragItem, monitor: DropTargetMonitor) {
            if (!ref.current) {
                return
            }
            const dragIndex = dragItem.index
            const hoverIndex = index

            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }

            // Determine rectangle on screen
            const hoverBoundingRect = ref.current!.getBoundingClientRect()

            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

            // Determine mouse position
            const clientOffset = monitor.getClientOffset()

            // Get pixels to the top
            const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top

            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%

            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return
            }

            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }

            // Time to actually perform the action
            moveCard(dragIndex, hoverIndex)

            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            dragItem.index = hoverIndex
        },
    })

    const [{isDragging}, drag] = useDrag({
        item: {type: 'card', id, index},
        collect: (monitor: any) => ({
            isDragging: monitor.isDragging(),
        }),
    })

    const opacity = isDragging ? 0 : 1;
    const image_file = item.image || {};
    drag(drop(ref));

    return (
        <div ref={ref} style={{...style, opacity}} className={`widget-item image-box-wrapper`}>
            {/*<span style={{margin:'50px'}}>{item.title || image_file.title}</span>*/}
            <div
                className={`image-box`}
                style={{backgroundImage: `url(${image_file.path})`}}>
                <div className={`image-hover-box`}>
                    <div className={'image-actions-wrapper'}>
                        {children}
                    </div>
                    <div className="image-box-bottom">
                        <span className={`image-title`}>{item.title || image_file.title}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GalleryItemPreview
